import axios from 'axios';

export const versionMixin = {
  data() {
    return {
      currentHash: '{{POST_BUILD_ENTERS_HASH_HERE}}',
      hashChanged: false,
      newHash: ''
    }
  },
  mounted() {
    if(this.isProductionEnv) this.initVersionCheck("version.json");
  },
  computed : {
    isProductionEnv(){
      return process.env.NODE_ENV === "production"
    }
  },
  methods: {
    initVersionCheck(url, frequency = 1000 * 60) {
      setInterval(async () => {
        await this.checkVersion(url);
      }, frequency);
    },
    async checkVersion(url) {
      try {
        const fileResponse = await axios.create({
          baseURL: `${location.origin}`,
          headers: {
            'Content-type': 'application/json'
          }
        }).get(url + '?t=' + new Date().getTime());

        this.newHash = fileResponse.data.hash;

        this.hashChanged = this.hasHashChanged(this.currentHash, this.newHash);
      } catch (error) {
        this.loading = false;
        if (!error.response) {
          this.errorStatus = 'Error: Network Error'
        } else {
          this.errorStatus = error.response.data.message;
        }
      }
    },
    hasHashChanged(currentHash, newHash) {
      if (!currentHash) {
        return true;
      }
      return currentHash !== newHash;
    },
    reloadApp() {
      this.currentHash = this.newHash;
      location.reload();
    },
  }
};
